import { useMemo, useEffect, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import { useTranslation } from 'react-i18next';
import { Divider } from "@mui/material";
import Utility from "../utility/utility";

function HCViewDKPD({ tableData }) {
    const { t } = useTranslation();

    const dataTableData = {
        columns: [
                {
                    Header: t(""), accessor: "planet", width: "5%", Cell: ({ cell }) =>
                        <p dangerouslySetInnerHTML={{ __html: `${Utility.getPlanetSymbol(cell.row.original.planet)}` }} />

                },
                {
                    Header: t("PLANET"), accessor: "", Cell: ({ cell }) =>
                        <p>{cell.row.original.planet} </p>

                },
            { Header: t("Place"), accessor: "place" },
            { Header: t("Rashiya"), accessor: "rashiya" },
            { Header: t("Nekatha"), accessor: "nekatha" },
            { Header: t("RashiBala"), accessor: "ucha" },
            { Header: t("WAKRA"), accessor: "wakra" },
            { Header: t("Awasthawa"), accessor: "awasthawa" },
        ],
        rows: tableData
    }

    return (
        <MDBox pt={0} pb={1} id="planets-ref">
            <MDBox mb={1}>
                <Card>
                    {/* <MDBox p={3} lineHeight={1} mb={0} display="flex" alignItems="center">
                        <MDTypography variant="h5" fontWeight="medium">
                            ග්‍රහස්ථුට
                        </MDTypography>
                        <Divider variant="fullWidth" sx={{ flexGrow: 1, marginLeft: 2 }} />
                    </MDBox> */}
                    <DataTable
                        canSearch={false}
                        entriesPerPage={false}
                        showTotalEntries={false}
                        table={dataTableData} />
                </Card>
            </MDBox>
        </MDBox>
    );
};

HCViewDKPD.propTypes = {
    tableData: PropTypes.array,
    cell: PropTypes.shape({
        row: PropTypes.shape({
            original: PropTypes.shape({
                planet: PropTypes.string.isRequired,
                place: PropTypes.string.isRequired,
                rashiya: PropTypes.string.isRequired,
                nekatha: PropTypes.string.isRequired,
                ucha: PropTypes.string.isRequired,
                wakra: PropTypes.string.isRequired,
                awasthawa: PropTypes.string.isRequired,
            }).isRequired,
        }).isRequired,
    }).isRequired,
};

export default HCViewDKPD;